module.exports = __webpack_public_path__ + "b646ee4325718a8ab6ac3cd5489882c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/beaker-s.png
// module id = 2486
// module chunks = 0